import React, {
  Fragment,
  cloneElement,
  useState,
  useRef,
  ReactElement,
  useEffect,
} from "react";
import { jsx, css } from "@emotion/react";
import PopoverHeader from "./popover-header";
import PopoverOverlay from "./popover-overlay";
import PopoverContent from "./popover-content";
// import useClickedOutside from "../../hooks/use-clicked-outside";
import baseStyles from "../../../../styles/base-styles";
import ConditionalWrapper from "../conditional-wrapper";

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    max-height: 100%;
    background: white;
    ${baseStyles.boxShadow};
    margin: auto;
  `,
  embededContainer: (top) => css`
    visibility: ${top ? "visible" : "hidden"};
    top: ${top}px;
    left: 50%;
    transform: translate(-50%, 0);
    position: absolute;
    z-index: 9;
    /* max-height: calc(
      100vh - 70px - 32px - 24px
    ); // max-heigh of parent minus max-top-offset */
    overflow-y: auto;
    ${baseStyles.boxShadow};
    ${baseStyles.verticalScrollbar}
  `,
};

interface IProps {
  isEmbedded?: boolean;
  onClose?: (argPassedFromClosingAction?: any) => void;
  onOpen?: () => void;
  title: string;
  render: (closePopover: (argToBePassedToEvent?: any) => void) => ReactElement;
  trigger?: (togglePopover: () => void, isOpen: boolean) => ReactElement;
  open?: boolean; // will open if true and close when false
}

const Popover = (props: IProps) => {
  //If trigger not specified open by default
  const [isPopoverOn, setIsPopoverOn] = useState(props.open);
  const containerRef = useRef(null);
  const [offsetTop, setOffsetTop] = useState<number | null>(null);

  // !props.isEmbedded && useClickedOutside(containerRef, () => closePopover())
  !("open" in props) &&
    !props.trigger &&
    console.warn(
      "Neither props.open nor props.trigger defined for Popover component. At least one required."
    );

  useEffect(() => {
    if (
      props.isEmbedded &&
      containerRef.current &&
      (containerRef.current as any)?.offsetParent
    ) {
      const height = (containerRef.current as any).offsetHeight;
      const parentHeight = (containerRef.current as any).offsetParent
        .offsetParent.offsetHeight;
      const ot = parentHeight >= height + 48 ? (parentHeight - height) / 2 : 24;
      ot !== offsetTop && setOffsetTop(ot);
      // console.log(height, top, offsetTop, ot)
    }
  });

  useEffect(() => {
    props.open ? openPopover() : closePopover();
  }, [props.open]);

  function togglePopover() {
    isPopoverOn ? closePopover() : openPopover();
    // setIsPopoverOn(prev => !prev)
    // !!props.onClose && props.onClose(prev => !prev)
  }
  function closePopover(argToBePassedToEvent?: any) {
    props.onClose && props.onClose(argToBePassedToEvent);
    setIsPopoverOn(false);
    // !!props.onClose && props.onClose(false)
  }
  function openPopover() {
    props.onOpen && props.onOpen();
    setIsPopoverOn(true);
    // !!props.onClose && props.onClose(false)
  }

  return (
    <Fragment>
      {props.trigger && props.trigger(togglePopover, !!isPopoverOn)}
      {isPopoverOn && (
        <ConditionalWrapper
          condition={!!props.isEmbedded}
          wrapperIfFalse={(child) => <PopoverOverlay>{child}</PopoverOverlay>}
          wrapperIfTrue={(child) => (
            <div css={styles.embededContainer(offsetTop)}>{child}</div>
          )}
        >
          <div ref={containerRef} css={styles.container}>
            <PopoverHeader title={props.title} onClose={() => closePopover()} />
            <PopoverContent>
              {props.render((arg) => closePopover(arg))}
            </PopoverContent>
          </div>
        </ConditionalWrapper>
      )}
    </Fragment>
  );
};

// Popover.Content = PopoverContent;

export default Popover;
